export default "__VITE_ASSET__DLOqpmGV__"